import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api, fmtDateTime } from "../lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export function NotificationBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [isOpen, setIsOpen] = useState(false);
  const nav = useNavigate();
  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  const toggle = async (o) => {
    setIsOpen(o);
    if (!o && data.unread) {
      await api.post("/notifications/read-all");
      load();
    }
  };
  const go = (n) => {
    toggle(false);
    if (n.link) nav(n.link);
  };
  return (
    <Popover open={isOpen} onOpenChange={toggle}>
      <PopoverTrigger asChild>
        <button className="relative p-2 rounded-full hover:bg-white/10" aria-label="Notifications" data-testid="notifications-bell">
          <Bell size={20} />
          {data.unread > 0 && <span className="absolute -top-0.5 -right-0.5 bg-amber-500 text-slate-900 text-[10px] font-bold rounded-full min-w-[18px] h-[18px] grid place-items-center" data-testid="notifications-count">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 z-[60] max-h-[70vh] overflow-y-auto" data-testid="notifications-panel">
        <div className="px-3 py-2 font-bold text-sm border-b">Notifications</div>
        {data.items.map((n) => (
          <button key={n.id} onClick={() => go(n)} className={`w-full text-left px-3 py-2 border-b text-sm hover:bg-slate-50 ${n.title.startsWith("ALERTE") ? "bg-red-50 text-red-800 border-l-4 border-l-red-600" : n.read ? "" : "bg-amber-50"} ${n.link ? "cursor-pointer" : "cursor-default"}`} data-testid={`notification-${n.id}`}>
            <div className="font-semibold">{n.title}</div>
            {n.body && <div className="text-xs text-slate-600">{n.body}</div>}
            <div className="text-[10px] text-slate-400 mt-0.5">{fmtDateTime(n.created_at)}</div>
          </button>
        ))}
        {!data.items.length && <div className="px-3 py-6 text-sm text-slate-500 text-center">Aucune notification.</div>}
      </PopoverContent>
    </Popover>
  );
}
